module.exports = __webpack_public_path__ + "static/6305-woodrose-52-42faaaf2f9fef95337f146d7dc061fe2.jpg";